export { default } from "./LicenseInfo";
